<template>
  <div class="container">
    <section class="section">
      <h1 class="title">Empleados o Colaboradores</h1>
      <h2 class="subtitle">
        Quienes son los colaboradores a los cuales le enviaremos las encuestas
        para hacer el estudio de Clima Organizacional
      </h2>
      <div class="field">
        <label class="label">Nombre</label>
        <div class="control">
          <input
            v-model="colaborador.nombre"
            class="input"
            type="text"
            placeholder="Nombre"
          />
        </div>
      </div>

      <div class="field">
        <label class="label">Correo</label>
        <div class="control">
          <input
            v-model="colaborador.email"
            class="input"
            type="email"
            placeholder="Correo"
          />
        </div>
      </div>
      <div class="field" v-for="(item, index) in dependencias" :key="index">
        <label class="label">{{ item.nombre }}</label>
        <div class="control">
          <input
            v-model="colaborador.dependencias[item._id]"
            class="input"
            type="text"
            :placeholder="item.nombre"
          />
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="savecolaborador()">
            Aceptar
          </button>
        </div>
        <div class="control">
          <button class="button is-light">Cancelar</button>
        </div>
      </div>
      <hr />
      <h2 class="subtitle">
        O puedes cargar los empleados desde un archivo en excel
      </h2>
      <button class="button is-link" @click="downexemple">
        Descargar Formato de Ejemplo
      </button>
      <button class="button is-light">Cargar Empleados</button>
      <hr />
      <h2 class="subtitle">Crear dependencias</h2>
      <div class="field">
        <label class="label">Nombre</label>
        <div class="control">
          <input
            v-model="dependencia.nombre"
            class="input"
            type="text"
            placeholder="Nombre de la dependencia o categoría"
          />
        </div>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link" @click="savedependencia()">
            Aceptar
          </button>
        </div>
        <div class="control">
          <button class="button is-light">Cancelar</button>
        </div>
      </div>

      <table class="table">
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Correo</th>
            <th v-for="(item1, index1) in dependencias" :key="index1">
              {{ item1.nombre }}
            </th>
            <th>
              <div class="buttons">
                <button class="button is-link">Enviar todos</button
                ><button class="button is-danger">Eliminar Todos</button>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in colaboradores" :key="index">
            <td>{{ item.nombre }}</td>
            <td>{{ item.email }}</td>
            <td v-for="(item1, index1) in dependencias" :key="index1">
              {{ item.dependencias ? item.dependencias[item1._id] : "" }}
            </td>
            <td>
              <button class="button is-light is-small">Editar</button>
              <button class="button is-danger is-small">Eliminar</button>
              <button class="button is-link is-small">Enviar</button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
export default {
  data() {
    return {
      colaborador: {
        nombre: "",
        email: "",
        dependencias: {},
      },
      colaboradores: [],
      dependencias: [],
      dependencia: {
        nombre: "",
      },
    };
  },
  methods: {
    async downexemple() {
      try {
        let result;
        result = await apiServices.post(
          `/downexempleempleados`,
          { np: "np" },
          { responseType: "blob" }
        );
        const url = window.URL.createObjectURL(new Blob([result.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(`download`, `Ejemplo.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        console.log(e);
      }
    },
    async getdependencias() {
      try {
        const result = await apiServices.get(`/getdependenciaclima`);
        if (result.data) {
          this.dependencias = result.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async savedependencia() {
      try {
        if (!this.dependencia.nombre) {
          this.$store.dispatch("notify", {
            message: "La dependencia debe tener un nombre.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        await apiServices.post(`/savedependenciaclima`, this.dependencia);
        this.dependencia.nombre = null;
        this.getdependencias();
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ya existe una dependencia con ese nombre.",
          type: "is-danger",
          position: "top-center",
          duration: 3000,
        });

        console.log(err);
      }
    },
    async savecolaborador() {
      try {
        if (!this.colaborador.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe incluir un nombre.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        if (!this.colaborador.email) {
          this.$store.dispatch("notify", {
            message: "Debe incluir el correo.",
            type: "is-warning",
            position: "top-center",
            duration: 3000,
          });
          return false;
        }
        await apiServices.post(`/savecolaboradorclima`, this.colaborador);
        this.getColaboradores();
        this.colaborador = {
          nombre: "",
          email: "",
          dependencias: {},
        };
        const _this = this;
        for (let index in _this.dependencias) {
          _this.colaborador.dependencias[_this.dependencias[index]._id] = null;
        }
      } catch (err) {
        console.log(err);
      }
    },
    async getColaboradores() {
      try {
        const result = await apiServices.get(`/colaboradoresclimalist`);
        if (result.data) {
          this.colaboradores = result.data.colaboradores;
          this.dependencias = result.data.dependencias;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getColaboradores();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/clima/menuclima/Loaddata.vue